module.exports = "<inbrit-kyc-details [isKycForApproval]=\"true\"></inbrit-kyc-details>"